const fontFamily =
  'Roboto, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

export { fontFamily };
